var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTulipCircleDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #00263d;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-6 {\n        fill: #00263e;\n      }\n\n      .cls-7 {\n        fill: #f2eda0;\n      }\n\n      .cls-8 {\n        fill: #9ac7e3;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 500,
    y1: 971.1,
    x2: 500,
    y2: 28.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003c75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00529b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 500,
    cy: 500,
    r: 471.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.9,562.8l-18.4,1.2-.3-5.1,5.1-.3c-3.5-1.7-6.3-5.1-6.6-10.9-.8-10.6,7.5-16.7,17.3-17.3,11.4-.8,19.3,6.1,19.9,16.3.5,8-3.7,14.6-11.4,15.8l-.3-5.7c4.3-.8,6.9-4.8,6.4-10-.5-6.9-6-11.2-14.1-10.7-7.4.5-13.7,4.5-13,12.3.5,6.1,4.9,9.5,10.3,9.4l-.8-10.7,4.9-.3.9,16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.1,614.5c-9.8,1.8-19.5-2.5-21.6-13.5-2.1-11,5.2-18.7,15-20.7,9.8-1.8,19.5,2.5,21.6,13.5,2,11-5.4,18.9-15,20.7ZM110.5,585.8c-6.9,1.4-12.3,6.4-10.7,14.1,1.5,7.7,8.3,10.4,15.2,9.1,6.9-1.4,12.3-6.4,10.9-14.1-1.7-7.7-8.4-10.4-15.3-9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M144.6,647.5l1.8,5.7-38.1-2.1-1.5-4.9,29.6-23.9,1.8,5.7-23.8,18.6,30.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.8,666.3l9.5,21-4.8,2.1-7.2-16-8.9,4,6.6,14.6-4.8,2.1-6.6-14.6-9.2,4.1,7.5,16.9-4.8,2.1-9.8-21.9,32.4-14.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.7,701.8l7.4,12.6c3.8,6.6,1.4,12.1-3.2,14.9-4,2.3-8.7,2.1-12.4-1.2l-8.3,15.8-3.4-5.7,7.8-14.3-3.8-6.4-12.1,7.1-2.8-4.8,30.8-18ZM167,709.2l-9.8,5.7,4.1,7.1c2.1,3.5,5.4,4.1,8.1,2.5,2.6-1.5,3.8-4.5,1.8-7.8l-4.3-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.3,760.4l-28.2,21.5-3.7-4.8,11-30.1-21.5,16.4-3.4-4.3,28.2-21.5,3.8,5.1-11,29.6,21.3-16.1,3.4,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212,816.7l4.1-8.6-10.9-11.2-8.7,3.8-4.1-4.3,35.3-14.6,4.5,4.5-15.7,34.8-4.5-4.5ZM210.3,794.6l8.3,8.4,7.1-15-15.3,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.7,824.1l-22.3,27.6-4.6-3.8,3.5-31.9-17,21-4.3-3.4,22.3-27.6,4.9,4-3.5,31.5,16.7-20.9,4.3,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303.6,870c-5.1,7.4-13.5,7.7-20.6,3.4-9.8-6.1-9.7-16.6-4.6-24.7,6-9.5,16.1-12.1,24.7-6.8,6.8,4.1,9.7,11.4,6.3,18.4l-4.9-3.1c1.8-3.8.2-8.3-4.3-11-5.8-3.7-12.6-1.7-16.9,5.2-3.8,6.1-4.1,13.4,2.6,17.5,4.5,2.8,9.7,2.6,12.9-2l4.8,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M329.4,857.7l20.9,9.8-2.3,4.8-15.8-7.5-4.1,8.7,14.4,6.8-2.3,4.8-14.4-6.8-4.3,9.1,16.7,7.8-2.3,4.8-21.8-10.3,15.3-31.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M360.8,903l-2,5.4c-2.3,6-6.8,6.8-10.7,5.8l.5-3.1c4,.8,5.7-.8,6.8-3.7l-2.8-1.1,2.1-5.7,6.1,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M422.8,900.7c.5-4.3-2.5-6.4-6.1-7.4-4.1-.9-7.2.2-8,3.7-.8,3.8,2.8,5.5,7.2,7.8,7.1,3.4,11.2,6.1,9.7,12.6-1.5,6.9-8,9.2-15,7.7-7.7-1.7-12.9-7.7-11.5-15.5l5.7,1.2c-.6,5.4,2.5,8.4,6.9,9.4,4.5.9,7.5-.3,8.3-3.5.8-3.7-2.6-5.4-6.4-7.2-8.1-4-11.8-7.2-10.4-13.4,1.5-6.9,7.7-9.1,14.7-7.5,6.9,1.5,12,6.1,10.6,13.4l-5.5-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M446.4,894.7l23,2.6-.6,5.2-17.5-2-1.1,9.7,15.8,1.8-.6,5.2-15.8-1.8-1.1,10,18.4,2.1-.6,5.2-23.9-2.8,4-35.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M514.9,921.2c-.5,8.9-7.5,13.7-15.8,13.7s-16.9-9.1-16.9-18.6,7.4-18.7,17.5-18.7,14.3,4.6,14.9,12.4h-5.7c-.5-4.3-4.3-7.2-9.5-7.2s-11.5,5.1-11.7,13.4c0,7.2,3.5,13.5,11.4,13.7,5.2,0,9.5-2.9,10-8.4l5.8-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M552.5,894.8l5.5-.6,2.6,22.3c1.1,9.1-4.1,14.6-12.4,15.5-8.1.9-14.7-3.1-15.8-12.3l-2.6-22.3,5.5-.6,2.6,21.9c.8,6,4.5,8.4,9.8,7.8,5.1-.6,8-3.7,7.4-9.4l-2.6-22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M574.7,891.2l14.3-3.4c7.5-1.8,12,2.1,13.2,7.5,1.1,4.5-.6,8.9-4.9,11.5l12.7,12.6-6.4,1.5-11.4-11.7-7.2,1.7,3.2,13.7-5.4,1.2-8.1-34.7ZM581.3,895l2.6,11,8-1.8c4-.9,5.5-3.8,4.8-7.1-.8-2.9-3.1-4.9-7.1-4l-8.3,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M621.4,878.4l11.2,33.8-5.4,1.7-11.2-33.8,5.4-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M662,862.2l2,4.8-10.9,4.6,12,27.8-5.1,2.1-12-27.8-10.9,4.6-2-4.8,26.9-11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M693.2,845.4l5.7-3.2-.6,24.7,7.1,12.4-4.9,2.8-7.1-12.4-21.5-12.3,5.7-3.2,16,9.8-.3-18.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M728.2,857.6l3.2,4.8c3.5,5.4,1.5,9.5-1.5,12.1l-2.1-2.3c2.9-2.8,2.6-5.1.9-7.7l-2.5,1.7-3.4-4.9,5.4-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M778.7,808.6c5.7,7.1,3.5,15.2-2.6,20.7-8.6,7.7-18.6,4.6-25-2.6-7.5-8.3-7.1-18.9.6-25.6,6-5.4,13.7-6.1,19.3-.8l-4.3,3.8c-3.2-2.9-8-2.5-11.8.9-5.2,4.6-5.2,11.5.3,17.6,4.8,5.4,11.7,7.7,17.5,2.5,4-3.5,5.2-8.4,1.7-12.9l4.3-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M809.4,767.3c7.5,6.6,10,16.9,2.6,25.5-7.4,8.6-18,7.5-25.5.9-7.5-6.6-10-16.9-2.6-25.3,7.4-8.6,18-7.5,25.5-1.1ZM790,789.4c5.2,4.6,12.6,5.8,17.8-.2,5.1-5.8,3.1-12.9-2.1-17.5-5.2-4.6-12.6-5.8-17.8.2-5.1,5.8-3.1,12.7,2.1,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M805.4,743.4l4.1-6.3,30.1,6.9-18.3-24.9,4.1-6.4,29.6,19.5-2.9,4.5-23.2-15.2,17.3,23.9-2.9,4.6-28.7-6.6,23,15.2-2.9,4.5-29.5-19.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M833.8,697.5l6.6-13.4c3.2-6.6,9.5-7.7,14.6-5.2,5.4,2.6,8.4,8.6,5.1,15.5l-3.8,7.8,12,5.8-2.5,5.1-31.9-15.7ZM840.8,694.7l10.7,5.2,3.5-7.4c1.8-3.7.8-6.9-2.6-8.6-3.1-1.5-6.3-.6-8,3.1l-3.7,7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M886.9,649.5l4.9,1.8-7.8,21.2-33.3-12.3,1.8-5.2,28.4,10.4,6-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M864.3,619.1l34.2,9.4-1.5,5.4-34.2-9.4,1.5-5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M908,583l-9.4,1.7-2.8,15.3,8.1,4.9-1.1,6-32.5-20.1,1.1-6.1,37.4-7.7-.9,6ZM891.2,597.3l2-11.7-16.4,3.1,14.4,8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M877.2,527.8l35.4,1.8-.3,6-27.9,15.8,27,1.5-.3,5.5-35.4-1.8.3-6.3,27.6-15.5-26.7-1.4.3-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M897.8,477.4c9.1-.2,14.1,6.4,14.7,14.7.8,11.5-7.7,17.5-17.3,18.1-11.2.8-19.2-6-19.9-16.1-.6-8,3.5-14.6,11.2-15.8l.5,5.7c-4.1.8-6.9,4.8-6.4,10,.5,6.9,6,11.2,14.1,10.6,7.2-.5,13.2-4.5,12.7-12.3-.3-5.2-3.5-9.4-9.1-9.4l-.5-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M872.7,463.6l-4.1-22.7,5.1-.9,3.2,17.2,9.5-1.7-2.9-15.7,5.2-.9,2.9,15.7,9.8-1.8-3.4-18.1,5.2-.9,4.3,23.6-34.8,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.9,69.4l.9,5.1-11.5,2.1,5.4,29.2-5.4.9-5.4-29.2-11.4,2.1-.9-5.1,28.2-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M470.5,65.4l5.4-.5,1.7,21.9c.8,8.9-4.6,14.1-12.7,14.7-8.1.6-14.3-3.5-15-12.6l-1.7-21.9,5.5-.5,1.7,21.6c.5,5.8,4.1,8.4,9.4,8.1,4.9-.5,8-3.2,7.5-8.9l-1.7-22.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.3,94.7l-.2,5.2-22.3-.5.8-34.8,5.5.2-.6,29.6,16.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M542.4,66.9l-3.4,34.7-5.5-.5,3.4-34.7,5.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M563.1,69.4l14.4,2.6c7.2,1.2,9.8,6.9,8.9,12.3-1.1,5.8-5.8,10.3-13.2,9.1l-8.4-1.5-2.3,12.9-5.4-.9,6-34.4ZM567.7,75.4l-2,11.5,7.8,1.4c4,.8,6.8-1.2,7.4-4.8.6-3.4-1.1-6-5.1-6.8l-8.1-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M506.8,138.2v704.5c191.5-3.5,345.6-159.9,345.6-352.3s-154.1-348.6-345.6-352.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M493.4,138.2c-191.5,3.5-345.6,159.9-345.6,352.3s154.1,348.6,345.6,352.3V138.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.1,698.4c3.7-3.1,8.1-2.1,11.2,1.2,4.5,4.6,2.9,10.1-1.1,14-4.8,4.6-10.6,4.1-14.3.3-2.9-3.1-3.7-7.2-.9-10.4l1.7,1.8c-1.7,2-1.2,5.1.9,7.2,2.8,2.9,6.9,3.1,10.7-.5,3.2-3.1,4.5-7.4,1.2-10.7-2.1-2.3-5.4-2.9-7.8-.9l-1.7-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.4,678c4.3-3.4,10.3-4,14.3,1.1,4,5.1,2.1,10.7-2.1,14.1-4.3,3.4-10.3,4-14.3-1.1-4-4.9-2.1-10.7,2.1-14.1ZM261.8,691.4c3.2-2.6,4.9-6.9,1.8-10.7s-7.5-3.2-10.9-.6c-3.2,2.6-4.9,6.9-1.8,10.7s7.7,3.2,10.9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.2,674l-1.8-2.9,10.9-14.6-17.8,4-1.8-2.9,16.7-10.7,1.2,2-14.1,9.1,17.5-3.8,1.2,2-10.6,14.4,14-9.1,1.2,2-16.6,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.3,644.9l-1.5-3.1,12.4-13.4-18.1,2.1-1.5-3.1,17.6-9.1,1.1,2.1-14.9,7.5,17.8-1.8,1.1,2.1-12.1,13.2,14.9-7.5,1.1,2-17.8,8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.4,594.2c5.1-2,10.9-.8,13.2,5.2,2.3,6-1.2,10.9-6.1,12.9-5.1,2-10.9.8-13.2-5.2-2.5-6.1,1.1-11,6.1-12.9ZM212.6,609.9c3.8-1.5,6.8-5.2,4.9-9.7-1.7-4.5-6.3-5.4-10.1-3.8-3.8,1.5-6.8,5.2-5.1,9.7,1.8,4.6,6.3,5.4,10.3,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M188.9,570.9l19.2-5.5.8,2.6-13,14.6,15.8-4.6.6,2.3-19.2,5.5-.8-2.9,12.9-14.3-15.7,4.5-.6-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.5,540.8l-.9-6.3c-.9-6.3,3.1-10.1,8.1-10.7,5.2-.8,10.6,1.8,11.7,8.6l.8,5.8-19.6,2.6ZM184.3,538.2l15.3-2.1-.5-3.5c-.8-5.2-4.8-6.9-8.9-6.3-4.1.6-7.1,3.2-6.4,8.1l.5,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.3,497.9l-5.2,2.3.5,9.2,5.5,1.8.2,2.6-20.3-6.9-.2-2.8,19.5-9.1v2.8ZM191.2,508.7l-.5-7.7-9.5,4.3,10,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.8,471.5h2.1l-.2,6.8,17.6.5v2.5l-17.6-.5-.2,6.8h-2.1l.3-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.8,448.9l-5.5,1.5-1.1,9.2,5.1,2.6-.3,2.6-18.9-10.1.3-2.8,20.6-5.8-.2,2.8ZM192.2,458.6l.8-7.5-10.1,2.8,9.4,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M186.5,416.1l.9-3.4,18.1-1.8-14.9-10.4.9-3.4,19.2,5.1-.6,2.3-16.3-4.3,14.6,10.4-.6,2.3-17.8,1.8,16.1,4.3-.6,2.3-19-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.2,370.2c5.1,1.8,8.6,6.8,6.4,12.7-2.3,6-8.1,7.4-13.2,5.5-5.1-1.8-8.6-6.8-6.4-12.7,2.3-6,8.3-7.4,13.2-5.5ZM205.4,386.1c3.8,1.4,8.4.6,10.1-4,1.7-4.6-1.1-8.1-5.1-9.5-3.8-1.4-8.4-.6-10.1,4-1.7,4.5,1.1,8,5.1,9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.9,355.3l2.8-5.8c2.8-5.8,8-6.8,12.7-4.5,4.8,2.3,8,7.4,4.9,13.5l-2.6,5.4-17.8-8.6ZM210,354.1l14,6.6,1.5-3.2c2.3-4.8-.2-8.4-4-10.3-3.7-1.8-7.7-1.2-9.8,3.2l-1.7,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.6,330l6.3-10.9,1.8,1.1-5.1,8.7,5.7,3.2,4.6-8,2,1.1-4.6,8,5.8,3.4,5.4-9.2,2,1.1-6.6,11.4-17.3-9.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.5,308l1.8,1.2-7.1,10.1-16.4-11.2,1.4-2,14.6,10,5.7-8.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M787,374.6c-4.5,1.5-8.3-.8-10.1-5.1-2.5-5.8.8-10.6,5.8-12.7,6-2.6,11.4-.2,13.5,4.8,1.7,3.8.9,8.1-2.8,10.1l-1.1-2.3c2.3-1.4,2.9-4.3,1.7-7.1-1.5-3.7-5.4-5.4-10.3-3.2-4.1,1.8-6.8,5.4-4.8,9.7,1.2,2.9,4,4.6,7.1,3.5l.9,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M799.4,400.9c-5.2,1.7-10.9.2-12.9-6-2-6.1,1.7-10.7,6.9-12.4,5.2-1.7,10.9-.2,12.9,6,2,6-1.8,10.7-6.9,12.4ZM794,384.8c-4,1.2-7.1,4.8-5.5,9.5,1.5,4.6,6,5.7,10,4.3,4-1.2,7.1-4.8,5.5-9.4-1.5-4.8-6-5.7-10-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M815.5,425.1l-19.3,4.5-.6-2.6,13.8-13.8-16.1,3.7-.5-2.3,19.3-4.5.6,2.9-13.7,13.5,16-3.7.5,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M820.1,454.7l-19.6,2.6-.3-2.8,15-12.4-16.3,2.1-.3-2.3,19.6-2.6.3,2.9-14.9,12.1,16.3-2.1.2,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M821.2,469.2l.5,12.6-2.1.2-.5-10.1-6.4.3.5,9.2-2.3.2-.5-9.2-6.6.3.5,10.6-2.3.2-.6-13,19.9-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M808,510.3c-4.8-.5-7.1-4.5-6.9-8.9.3-6.3,5.2-9.2,10.7-8.9,6.6.3,10.3,4.8,10.1,10.1-.2,4.3-2.8,7.7-6.9,8l.2-2.5c2.6-.2,4.5-2.6,4.6-5.7.2-4-2.6-7.2-7.8-7.4-4.5-.2-8.4,1.8-8.6,6.6-.2,3.2,1.5,5.8,4.8,6.3l-.2,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M818.4,535.6l-2.1-.3.8-6.8-17.5-2.1.3-2.5,17.5,2.1.8-6.8,2.1.3-1.8,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M803.2,561.7c-5.4-1.1-9.5-5.4-8.3-11.7,1.4-6.3,6.9-8.4,12.1-7.4,5.4,1.1,9.5,5.4,8.3,11.7-1.2,6.3-6.8,8.4-12.1,7.4ZM806.8,545.1c-4-.9-8.4.6-9.5,5.4-.9,4.8,2.3,7.8,6.4,8.7,4,.9,8.4-.6,9.5-5.4,1.1-4.8-2.3-7.8-6.4-8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M809.8,575.8l-2.3,7.4c-1.2,4-4.3,5.1-7.1,4.3-2.5-.8-4.1-2.9-4.1-5.8l-10,2.6.8-2.8,9.4-2.5,1.4-4.5-8-2.5.8-2.3,19.2,6ZM806.9,577.5l-6.9-2.1-1.4,4.8c-.8,2.5.5,4.3,2.3,4.9,1.8.6,3.7-.2,4.5-2.6l1.5-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M792.5,609.6c2.5.8,4.3-.9,5.1-3.1.9-2.5.6-4.5-1.5-5.4-2.3-.9-3.7.9-5.5,3.5-2.5,3.2-4.3,5.5-7.7,4.1-3.5-1.4-4.3-5.1-2.8-8.6,1.7-4.1,5.4-6.1,9.4-4.8l-.9,2.3c-3.2-.9-5.4.8-6.3,3.2-1.1,2.5-.5,4.6,1.5,5.5,2.3.9,3.7-.9,5.1-2.9,2.9-4.1,5.1-5.8,8.1-4.6,3.5,1.4,4.3,4.8,2.8,8.4-1.4,3.5-4.1,5.8-8,4.5l.8-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.1,778.2c154.5,0,279.7-125.2,279.7-279.7s-125.3-279.7-279.7-279.7-279.7,125.2-279.7,279.7,125.2,279.7,279.7,279.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.9,291.5l2.8-1.8,11.5,10.4-4.5-15.2,2.6-1.7,12.1,10.1-5.1-14.7,2.6-1.8,6.1,19.5-2.6,1.7-12.1-10,4.5,15.2-2.6,1.7-15.3-13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M403.6,270.9c2.3,5.1,1.2,10.9-4.5,13.5-5.7,2.6-10.7-.3-13.2-5.4-2.3-5.1-1.2-10.7,4.5-13.5,5.7-2.6,10.9.3,13.2,5.4ZM388.9,277.6c1.7,3.5,5.1,5.8,9.1,4,3.8-1.8,4.5-5.8,2.9-9.4-1.7-3.5-5.1-5.8-9.1-4s-4.6,5.8-2.9,9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M415,256l7.8-2.5c4.1-1.2,6.8.8,7.7,3.5.8,2.5,0,4.9-2.3,6.6l7.5,6.4-3.5,1.1-6.8-6-4,1.2,2.3,7.4-2.9.9-5.8-18.7ZM418.8,257.8l1.8,6,4.5-1.4c2.1-.6,2.9-2.5,2.3-4.1-.5-1.7-2-2.6-4-2l-4.6,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M444.9,247.7l3.1-.6,1.8,9.4,6.8-11,4-.8-6,9.4,10.1,9.8-3.8.8-8-8-2.3,3.5,1.1,6.1-3.1.6-3.7-19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M486.6,247.7c-.5-2.3-2.3-3.1-4.5-2.9-2.3.2-3.8,1.2-3.7,3.2.2,2.1,2.3,2.6,5.1,3.1,4.3.6,6.9,1.5,7.2,5.2.3,3.8-2.8,6.1-6.8,6.4-4.5.3-8.1-2-8.6-6.4l3.2-.2c.5,2.9,2.6,4.1,5.2,4,2.5-.2,4-1.4,3.8-3.2-.2-2.1-2.3-2.5-4.6-2.9-4.9-.8-7.4-2-7.7-5.5-.3-3.8,2.6-6,6.6-6.3,3.8-.3,7.4,1.4,7.8,5.5h-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M506.1,242l8.3.5c4.1.2,6,3.2,5.8,6.3-.2,3.4-2.6,6.1-6.9,6l-4.8-.3-.5,7.4-3.1-.2,1.1-19.6ZM509.1,245l-.3,6.6,4.6.3c2.3.2,3.7-1.1,3.8-3.2.2-1.8-1.1-3.4-3.4-3.4l-4.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M544.5,266l-1.1-5.2-8.6-1.4-2.6,4.6-3.4-.6,11-18.1,3.4.6,4.5,20.7-3.2-.6ZM536.5,256.6l6.4,1.1-1.8-9.1-4.6,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M578.3,267.7c-1.7,4.8-6.1,6-10.6,4.8-6.1-1.8-7.5-7.5-6-12.6,1.8-6,6.9-8.7,12.3-7.1,4.3,1.2,6.9,4.8,6,8.9l-3.1-.9c.5-2.3-1.1-4.5-3.8-5.4-3.7-1.1-6.9.9-8.3,5.2-1.2,3.8-.3,7.8,3.8,9.1,2.8.9,5.5,0,6.6-2.9l3.1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M597.1,261.4l11.8,5.2-1.2,2.6-8.9-4-2.1,4.9,8.1,3.5-1.2,2.6-8.1-3.5-2.3,5.1,9.4,4.1-1.2,2.6-12.3-5.4,8.1-17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M629.8,284.2c1.1-2.1-.2-3.8-2-4.9-2-1.2-3.8-1.1-4.9.6-1.1,1.8.5,3.4,2.5,5.4,3.1,2.9,4.9,5.2,2.9,8.3-2,3.4-5.8,3.5-9.2,1.5-3.8-2.3-5.5-6.3-3.4-10.1l2.8,1.7c-1.2,2.8-.2,4.9,2,6.1,2.1,1.2,4,1.1,4.9-.5,1.1-1.8-.5-3.2-2.1-4.9-3.7-3.5-5.1-5.8-3.2-8.9,2-3.4,5.5-3.5,9.1-1.5,3.4,2,5.2,5.2,3.4,8.9l-2.6-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M494.8,513.4v-226.3c-117.9,2.8-212.7,99.3-212.7,217.9s0,5.7.2,8.4h212.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M505.4,513.4h212.5c.2-2.8.2-5.5.2-8.4,0-118.6-94.7-215.1-212.7-217.9v226.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M494.8,523.8h-211.9c9.5,109.7,100.2,196.3,211.9,199v-199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M505.4,523.8v199c111.6-2.6,202.4-89.2,211.9-199h-211.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M368.8,399.2l-4.4-1.1-4.4,6,2.5,3.8-1.6,2.4-9.8-15.3,1.8-2.4,17.6,4.4-1.8,2.2ZM358.8,401.7l3.3-4.5-7.6-2,4.4,6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M363.3,379.2l4.7-5.3c2.4-2.5,5.3-2.2,7.3-.5,2.2,1.8,2.7,5.1.4,7.8l-2.7,3.1,4.7,4.2-1.8,2-12.5-11.3ZM366.8,378.8l4.2,3.8,2.5-2.9c1.3-1.5,1.3-3.1,0-4.2-1.3-1.1-2.7-1.1-4,.4l-2.7,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M380.2,361.6l11.6,12.2-2,1.8-11.6-12.2,2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M610.1,377.9l1.5-4.4-5.8-4.5-3.8,2.4-2.2-1.8,15.6-8.9,2.4,1.8-5.3,17.3-2.4-1.8ZM607.9,367.6l4.4,3.5,2.4-7.5-6.7,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M630.3,373.4l4.9,4.9c2.5,2.5,2,5.5,0,7.3-2,2-5.1,2.5-7.8-.2l-2.9-2.9-4.4,4.4-1.8-1.8,12-11.6ZM630.5,377l-4,4,2.7,2.7c1.5,1.5,2.9,1.5,4.2.2,1.1-1.1,1.3-2.7-.2-4l-2.7-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M645.4,389.2l4.5,5.5c2.2,2.7,1.5,5.6-.7,7.3-2.2,1.8-5.4,2-7.6-.9l-2.5-3.3-4.9,4-1.6-2,12.9-10.5ZM645.2,392.8l-4.4,3.6,2.4,3.1c1.3,1.5,2.9,1.6,4.2.5,1.3-1.1,1.4-2.5.4-4l-2.5-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M659.9,416.8c1.6-1.3,1.3-3.1.4-4.5-1.1-1.6-2.5-2.4-3.8-1.5-1.5.9-.9,2.7-.2,5.1,1.3,3.5,1.8,5.8-.9,7.5-2.7,1.8-5.8.5-7.6-2.4-2-3.1-1.8-6.9,1.3-9.1l1.5,2.4c-2,1.6-2,3.6-.7,5.5,1.1,1.8,2.7,2.4,4,1.5,1.5-.9.9-2.7.2-4.5-1.5-4-1.6-6.4.9-8,2.7-1.8,5.6-.5,7.5,2.4,1.8,2.7,2,6-.7,8l-1.6-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M658.1,554.6l3.8-.3,1.7-6-3.1-2.1.6-2.3,12.3,9.2-.6,2.5-15.2,1.7.5-2.6ZM665.3,549.4l-1.2,4.6,6.6-.6-5.4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M665,576.9l-.8,2-8.3-3.4c-3.4-1.4-4.3-4.1-3.1-7.4,1.2-3.1,3.8-4.6,7.4-3.2l8.3,3.4-.8,2-8.1-3.2c-2.3-.9-3.8,0-4.6,2-.8,1.8-.3,3.5,1.8,4.3l8.1,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M655.6,596.1l-1.8-.9,2.1-4.1-10.7-5.7,1.1-2,10.7,5.7,2.1-4.1,1.8.9-5.4,10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M638.6,609.3c-3.4-2.3-4.8-6.3-2.3-10,2.6-3.7,6.8-3.8,10.1-1.5,3.2,2.3,4.8,6.1,2.3,10-2.6,3.7-6.8,3.7-10.1,1.5ZM645.2,599.6c-2.3-1.5-5.2-1.7-7.1.9-1.7,2.6-.6,5.2,1.7,6.9,2.3,1.5,5.4,1.7,7.1-.9,1.8-2.6.6-5.4-1.7-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M638.9,620.3l-2,2.3-11.5-4.5,5.8,10.9-2,2.3-10.6-9.4,1.4-1.5,8.3,7.4-5.5-10.4,1.4-1.7,11,4.3-8.3-7.4,1.4-1.5,10.6,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M605.1,634.1l3.4,1.8,4.8-4.1-1.4-3.5,1.8-1.5,5.1,14.4-1.8,1.7-13.7-6.9,1.8-1.8ZM614,634l-3.5,3.1,5.8,3.1-2.3-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M598.1,657l-1.2-1.7,3.8-2.8-6.9-10,1.8-1.2,6.9,10,3.8-2.8,1.2,1.7-9.5,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M589.6,662.2l-7.2-12.3,2-1.1,7.2,12.3-2,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M566.4,665.9c-1.7-3.7-.9-7.8,3.2-9.7,4.1-1.8,7.8.2,9.5,3.8,1.7,3.5.9,7.8-3.2,9.7-4.1,1.8-7.8-.2-9.5-3.8ZM577,661c-1.2-2.6-3.7-4.1-6.4-2.8-2.8,1.4-3.2,4.1-2,6.8s3.7,4.1,6.4,2.9c2.8-1.4,3.1-4.3,2-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M550.2,679.1l-4.5-13.5,2.3-.8,10,8.1-3.4-10.3,2.1-.6,4.5,13.5-2.5.8-9.8-8.1,3.4,10.1-2.1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M531.8,679.4c.5,1.7,2,2,3.5,1.7,1.7-.3,2.6-1.2,2.3-2.6-.3-1.5-1.8-1.5-3.8-1.7-3.1-.2-5.1-.5-5.5-3.1-.6-2.8,1.4-4.8,4.1-5.2,3.1-.6,6,.8,6.8,3.8l-2.3.5c-.6-2-2.3-2.6-4-2.3-1.8.3-2.6,1.4-2.5,2.6.3,1.5,1.8,1.5,3.5,1.5,3.7.2,5.5.8,6,3.2.6,2.8-1.4,4.6-4.1,5.1-2.8.6-5.4-.3-6-3.2l2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M500,644.2c78.1,0,141.5-63.3,141.5-141.5s-63.3-141.5-141.5-141.5-141.5,63.3-141.5,141.5,63.3,141.5,141.5,141.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M500,505.5l51.4-51.4-51.4-51.4-51.4,51.4,51.4,51.4ZM490.8,521.9v72.6l-72.6-72.6v-72.6l72.6,72.6ZM582.1,449.4v72.6l-72.6,72.6v-72.6l72.6-72.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M433.2,679.1l-2.4-1.2,2.7-12.4-8.8,9.3-2.2-1.1,2.2-12.7-8.3,9.6-2.3-1.2,11.2-12.3,2.2,1.1-2.1,12.6,8.9-9.2,2.2,1.1-3.2,16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M405.1,663.8l8.5-13.5,2.1,1.3-8.5,13.5-2.1-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M397.4,658.7l-4.4-3.3c-4.2-3.1-4.1-7.5-1.5-10.8,2.5-3.4,7.1-5.1,11.5-1.7l4.1,3.1-9.6,12.8ZM396.8,655.4l6.8-9-2.1-1.6c-3.1-2.3-6.1-1.2-8,1.4-1.8,2.4-2,5.2.9,7.4l2.3,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M375.4,630.1l5.7-6.1,1.6,1.6-1.6,1.6c1.7-.5,3.6-.2,5.5,1.5,3.5,3.3,2.7,7.8-.4,11.1-3.5,3.7-8.2,3.9-11.6.7-2.6-2.5-3.3-5.9-1.1-8.7l1.9,1.8c-1.2,1.5-.8,3.7.9,5.3,2.3,2.1,5.4,1.9,7.9-.8,2.3-2.4,3.1-5.6.5-8.1-2-1.9-4.5-1.6-6.3,0l3.5,3.3-1.5,1.6-5.3-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M363.8,628.9l-6.8-7.9,1.8-1.5,5.2,6,3.3-2.8-4.7-5.5,1.8-1.5,4.7,5.5,3.4-2.9-5.4-6.3,1.8-1.5,7.1,8.2-12.1,10.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345,604.7l1.9-1.4,3.1,4.4,11.1-7.9,1.5,2.1-11.1,7.9,3.1,4.3-1.9,1.4-7.6-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M340.5,588.5c-1.6,1.1-1.4,2.8-.6,4.3,1,1.7,2.3,2.3,3.6,1.6,1.5-.9,1-2.6.4-4.8-1-3.3-1.3-5.6,1.3-7.1,2.8-1.6,5.5-.1,7.1,2.6,1.8,3.1,1.4,6.6-1.7,8.5l-1.3-2.3c2-1.4,2.1-3.4,1-5.2-1-1.8-2.4-2.4-3.7-1.7-1.5.9-1,2.5-.5,4.3,1.2,3.9,1.2,6.1-1.3,7.5-2.8,1.6-5.4.2-7-2.6-1.6-2.8-1.6-5.8,1.2-7.6l1.3,2.3Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTulipCircleDiagram);
export default __webpack_public_path__ + "static/media/TulipCircleDiagram.9a9f1964394be9facb1290be7ebdad8d.svg";
export { ForwardRef as ReactComponent };